import { createFileRoute } from '@tanstack/react-router';

import { OrderTrackPage } from '@sampling';

export const Route = createFileRoute('/_app/_admin/orders_/$id/track')({
  component: OrderTrackPage,
});
